<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { ChevronRight } from 'lucide-vue-next';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <li role="presentation" aria-hidden="true" :class="cn('[&>svg]:tw-size-3.5', props.class)">
    <slot>
      <ChevronRight />
    </slot>
  </li>
</template>
